export { default } from './ScrollBox';



// WEBPACK FOOTER //
// ./src/design-system/atoms/ScrollBox/index.jsx